<template>
  <el-dialog v-dialogDrag class="setting" title="设置" :visible.sync="isShow" width="800px" append-to-body
    :close-on-click-modal="false">
    <el-tabs v-model="tabValue" tab-position="left" style="min-height: 400px" @tab-click="onClickTab">
      <el-tab-pane label="个人资料">
        <personal-info ref="personalInfo" @saved="close" />
      </el-tab-pane>
      <el-tab-pane label="修改密码">
        <modify-password @saved="close" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import ModifyPassword from "../setting/ModifyPassword.vue";
import PersonalInfo from "../setting/PersonalInfo.vue";

export default {
  name: "SettingUserInfo",
  components: {
    PersonalInfo,
    ModifyPassword
  },
  data() {
    return {
      isShow: false,
      tabValue: "0"
    };
  },
  methods: {
    open() {
      this.tabValue = "0";
      this.isShow = true;
      this.$nextTick(() => this.onClickTab());
    },
    close() {
      this.isShow = false;
    },
    onClickTab() {
      if (this.tabValue == "0") {
        this.$refs.personalInfo.init();
      }
    }
  }
};
</script>

<style lang="scss"></style>
